import React, { useContext } from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';
import { StyledPropsWithChildren } from '@front10';

type AnchorProps = JSX.IntrinsicElements['a'];

interface Props {
  /**
   * Disable or enable button.
   */
  disabled?: boolean;
  /**
   * Button tooltip.
   */
  tooltip?: AnchorProps['title'];
}

export type LinkProps = StyledPropsWithChildren<
  Props & Pick<AnchorProps, 'href' | 'target' | 'onClick'>
>;

function Link({ tooltip, href, target, children, onClick, ...props }: LinkProps) {
  const { direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });
  return (
    <a
      onClick={onClick}
      title={tooltip}
      className={className}
      href={href}
      target={target}
      style={style}
    >
      {children}
    </a>
  );
}

Link.defaultProps = {
  disabled: false,
};

Link.componentName = 'Link';

export default Link;
